import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import FilterFooter from '~/client/src/desktop/components/Filters/FilterFooter/FilterFooter'
import SavedFiltersHeader from '~/client/src/desktop/components/Filters/SavedFilters/SavedFiltersHeader'
import { Checkbox } from '~/client/src/shared/components/shadcn-ui/checkbox'
import StruxhubInput from '~/client/src/shared/components/StruxhubInputs/StruxhubInput'
import KnownTranslatorKeys from '~/client/src/shared/localization/knownTranslatorKeys'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import DesktopDeliverySavedFiltersStore from '../../DeliverySavedFilters/DesktopDeliverySavedFilters.store'
import DesktopSavedFiltersStore from '../DesktopSavedFilters.store'

import '../SavedFilters.scss'

// localization: translated

interface ISaveFilterProps {
  filterName: string
  isPublic: boolean
  entitiesCountByFilter?: number
  filtersCount?: number
  className?: string
  filtersDescriptions: string[]
  toggleIsPublic: () => void
  clickOnApply: () => void
  clickOnCancel: () => void
  onNameChange: (event) => void
  desktopSavedFiltersStore:
    | DesktopSavedFiltersStore
    | DesktopDeliverySavedFiltersStore
  xEntitiesTranslatorKey: KnownTranslatorKeys
}

@observer
export default class SaveFilterDialog extends React.Component<ISaveFilterProps> {
  public render() {
    const {
      filterName: value,
      entitiesCountByFilter,
      filtersCount,
      filtersDescriptions,
      clickOnApply,
      clickOnCancel,
      onNameChange,
      toggleIsPublic,
      isPublic,
      xEntitiesTranslatorKey,
      className,
    } = this.props

    return (
      <div
        className={classList({
          'filter-container saved': true,
          [className]: !!className,
        })}
      >
        <SavedFiltersHeader
          desktopSavedFiltersStore={this.props.desktopSavedFiltersStore}
        />
        <div className="filter-container-content mx15">
          <div className="row name y-center">
            <StruxhubInput
              label={Localization.translator.filterName}
              isRequired={true}
              isRequiredTextHidden={true}
              value={value}
              onChange={onNameChange}
            />
            <label className="mt20 ml40 row y-center text large tw:cursor-pointer tw:gap-2">
              <Checkbox
                className="no-grow"
                checked={isPublic}
                onCheckedChange={toggleIsPublic}
              />
              {Localization.translator.makePublic}
            </label>
          </div>
          <div>
            <span className="text extra-large bold mr10">
              {Localization.translator.selectedFilters}
            </span>
            <span className="text extra-large light">
              ({Localization.translator.xFilters(filtersCount)})
            </span>
          </div>
          {filtersDescriptions.map((label, idx) => (
            <div className="row py5" key={idx}>
              <div className="no-grow px10 text primary-blue">•</div>
              <div className="text large ellipsis">{label}</div>
            </div>
          ))}
          <div className="no-grow text extra-large light nowrap pt5">
            {Localization.getText(
              xEntitiesTranslatorKey,
              entitiesCountByFilter,
            )}
          </div>
        </div>
        <div className="bt-light-grey mt10">
          <FilterFooter
            clickOnApply={clickOnApply}
            clickOnCancel={clickOnCancel}
            isApplyButtonInactive={!value}
            applyButtonText={Localization.translator.save}
          />
        </div>
      </div>
    )
  }
}
